module.exports = __webpack_public_path__ + "img/upload-file.4d608453.svg";